import { render, staticRenderFns } from "./UsuariosAdmin.vue?vue&type=template&id=7f23b9e6&"
import script from "./UsuariosAdmin.vue?vue&type=script&lang=js&"
export * from "./UsuariosAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports